import React from 'react';
import { Button, LinkButton } from '@/components/ui/Buttons';
import Text from '@/components/ui/Text';
import I18n from '@/modules/i18n';

interface BulkBarContentProps {
  actionLabel: string;
  color?: ButtonColors;
  count: number;
  disabled: boolean;
  onAction: () => void;
  onClear: () => void;
}

// Shared by the table's bulk-remove row and the Add panel's bulk-add bar, which differ only in where
// they sit, the action button and its colour.
const BulkBarContent = ({
  actionLabel, color, count, disabled, onAction, onClear,
}: BulkBarContentProps) => (
  <div className="tw-flex tw-items-center tw-gap-4">
    {/* SelectionAnnouncer carries this string for AT; hidden here so it isn't heard twice. */}
    <Text aria-hidden className="tw-text-very-dark-grey" size="sm" tag="span">
      {I18n.t('n_selected', { count })}
    </Text>
    <LinkButton className="tw-text-tci-purple" onClick={onClear}>
      <Text size="sm" tag="span">{I18n.t('clear_selection')}</Text>
    </LinkButton>
    <Button small color={color} disabled={disabled} onClick={onAction}>
      {actionLabel}
    </Button>
  </div>
);

export default BulkBarContent;
